import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "./constants";

const userService = createApi({
  reducerPath: "userService",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL, // Base URL for all API requests
  }),
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (formData) => ({
        url: "admin/login",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useSignInMutation } = userService;
export default userService;
